/* eslint-disable @typescript-eslint/naming-convention */
import * as yup from 'yup';

export const validationSchema = yup
  .object({
    user_id: yup.number().optional(),
    arthritis: yup.boolean().optional(),
    cancer: yup.boolean().optional(),
    dementia_alzheimers: yup.boolean().optional(),
    diabetes: yup.boolean().optional(),
    heart_disease: yup.boolean().optional(),
    dry_mouth: yup.boolean().optional(),
    obesity: yup.boolean().optional(),
    pregnancy_or_breastfeeding: yup.boolean().optional(),
    respiratory_conditions: yup.boolean().optional(),
    stroke: yup.boolean().optional(),
    conditions_not_listed: yup
      .string()
      .max(250, 'Maximum 250 characters')
      .nullable()
      .optional()
      .test('not-with-none-of-the-above', 'Cannot enter text when "None of the above" is selected', function (value) {
        const noneSelected = this.parent.none_of_the_above === true;
        return noneSelected ? !value || value.trim() === '' : true;
      })
      .test('required-if-selected', 'Please describe the condition(s)', function (value) {
        // This handles the case where conditions_not_listed is "selected" (i.e. not empty but invalid)
        const raw = value as string | undefined;
        if (raw === 'true' || raw?.trim() === 'true') {
          return false;
        }
        return true;
      }),
    none_of_the_above: yup
      .boolean()
      .optional()
      .test('exclusive-none', 'Cannot select other conditions when "None of the above" is selected', function (value) {
        if (value !== true) return true;
        const otherSelected = Object.entries(this.parent).some(
          ([key, val]) =>
            key !== 'none_of_the_above' && key !== 'user_id' && key !== 'conditions_not_listed' && val === true,
        );
        return !otherSelected;
      }),
  })
  .test('at-least-one-selected', 'At least one condition must be selected', function () {
    const formData = (this.options as any).originalValue || {};

    const fields = [
      'arthritis',
      'cancer',
      'dementia_alzheimers',
      'diabetes',
      'heart_disease',
      'dry_mouth',
      'obesity',
      'pregnancy_or_breastfeeding',
      'respiratory_conditions',
      'stroke',
      'none_of_the_above',
    ];

    const anySelected = fields.some((field) => formData[field] === true);
    if (
      formData.conditions_not_listed &&
      typeof formData.conditions_not_listed === 'string' &&
      formData.conditions_not_listed.trim() !== ''
    ) {
      return true;
    }
    return anySelected;
  });
